const checkStatus = (status) => {
  return status === 'OK' ? 'OK' : status === 'NG' ? 'NG' : 'WARN';
};

const checkColor = (status) => {
  return status === 'OK' ? '#40A631' : status === 'NG' ? '#C64F3E' : '#ea8200';
};

const defineStatus = (min, max, value) => {
  if (value < min || value > max) {
    return 'NG';
  } else if (value > min + 1 && value < max - 1) {
    return 'OK';
  } else {
    return 'WARN';
  }
};

export { checkStatus, checkColor, defineStatus };
